import type { Message } from './use-chat';

export const chatHistoryCache = new Map<string, Message[]>();
export const pendingNotificationTaps = new Map<string, { requestId: string; createdAt: number; snapshotToken?: string; prepareAttempted?: boolean }>();
// The owner's idempotency ledger is finite. A lost prepare response must not allow an old request
// to capture a group's newer membership after that ledger is pruned. This is only a retry deadline,
// never a client-supplied read boundary; obtained frozen tokens keep their server expiry behavior.
export function notificationPrepareExpired(createdAt: number): boolean {
  const age = Date.now() - createdAt;
  return !Number.isFinite(age) || age < 0 || age >= 10 * 60_000;
}
let readEpoch = 0;
let pendingReads = 0;
export function invalidateChatReadResponses(): number { return ++readEpoch; }
export function chatReadEpoch(): number { return readEpoch; }
export function beginChatRead(): number { pendingReads += 1; return invalidateChatReadResponses(); }
export function settleChatRead(started: number): number {
  const current = started === readEpoch;
  pendingReads = Math.max(0, pendingReads - 1);
  const settled = invalidateChatReadResponses();
  return current && pendingReads === 0 ? settled : -1;
}
export function pendingChatReadCount(): number { return pendingReads; }
export function clearChatSession(): void {
  invalidateChatReadResponses();
  chatHistoryCache.clear();
  pendingNotificationTaps.clear();
}
